import { apiClient } from "../client";

/**
 * Cria um novo planejamento
 */
export const createPlan = async (planData) => {
  const { data } = await apiClient.post("/plans", planData);
  return data;
};

/**
 * Lista planejamentos com filtros e paginação
 */
export const listPlans = async (filters = {}, page = 1, limit = 10) => {
  const params = new URLSearchParams();
  
  if (filters.teacherId) params.append("teacherId", filters.teacherId);
  if (filters.subjectId) params.append("subjectId", filters.subjectId);
  if (filters.gradeId) params.append("gradeId", filters.gradeId);
  if (filters.planType) params.append("planType", filters.planType);
  if (filters.checkStatus) params.append("checkStatus", filters.checkStatus);
  if (filters.startDate) params.append("startDate", filters.startDate);
  if (filters.endDate) params.append("endDate", filters.endDate);
  
  // Paginação
  params.append("page", page.toString());
  params.append("limit", limit.toString());

  const queryString = params.toString();
  const url = `/plans?${queryString}`;
  
  const { data } = await apiClient.get(url);
  return data;
};

/**
 * Atualiza um planejamento
 */
export const updatePlan = async (planId, planData) => {
  const { data } = await apiClient.put(`/plans/${planId}`, planData);
  return data;
};

/**
 * Alterna o status de verificação de um planejamento
 */
export const toggleCheck = async (planId) => {
  const { data } = await apiClient.put(`/plans/${planId}/check`);
  return data;
};

/**
 * Alterna a permissão de edição de um planejamento
 */
export const toggleEditEnabled = async (planId) => {
  const { data } = await apiClient.put(`/plans/${planId}/enable-edit`);
  return data;
};

